//#region src/quicksand_record_sync_type.ts
var QuicksandRecordSyncType = /* @__PURE__ */ function(QuicksandRecordSyncType) {
	QuicksandRecordSyncType["Automatic"] = "automatic";
	QuicksandRecordSyncType["Manual"] = "manual";
	QuicksandRecordSyncType["Webhook"] = "webhook";
	return QuicksandRecordSyncType;
}(QuicksandRecordSyncType || {});
//#endregion
export { QuicksandRecordSyncType };

//# sourceMappingURL=quicksand_record_sync_type.js.map